import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { LearnLayoutContextValue } from "#learn-layout-context-value";

export const LearnLayoutContext = createContext(
  defaultError<LearnLayoutContextValue>("LearnLayoutContext"),
);
